import { Switch } from 'react-router-dom';
import ChangeUserPasswordContainer from './ChangeUserPassword/ChangeUserPasswordContainer';
import CreateUserContainer from './CreateUser/CreateUserContainer';
import UserSettingsContainer from './Settings/UserSettingsContainer';
import { usePermissions } from '../../providers/Permissions.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import UsersList from './UsersList';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <ProtectedRoute isAllowed={!!permissions.ViewUsers} showPermission exact path="/users" component={UsersList} />
      <ProtectedRoute
        isAllowed={!!permissions.AddUsers}
        showPermission
        exact
        path="/users/create"
        component={CreateUserContainer}
      />
      <ProtectedRoute
        isAllowed={!!permissions.AddUsers}
        showPermission
        exact
        path="/users/change-password/:emailAddress"
        component={ChangeUserPasswordContainer}
      />
      <ProtectedRoute isAllowed showPermission exact path="/users/settings" component={UserSettingsContainer} />
    </Switch>
  );
};
export default Routes;
